import context from "@helpers/context"

const [SalonContext, useSalonContext] = context<Customer.Contexts.Salon>()

export default SalonContext
export { useSalonContext }